import january from './01_january.js';
import february from './02_february.js';
import march from './03_march.js';
import april from './04_april.js';
import may from './05_may.js';
import june from './06_june.js';
import july from './07_july.js';
import august from './08_august.js';
import defaultData from './default.js';

const combinedHistoryData = {
    ...january,
    ...february,
    ...march,
    ...april,
    ...may,
    ...june,
    ...july,
    ...august,
    ...defaultData
};

export default combinedHistoryData;
